let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6kM20")).then(() => parcelRequire('3980j'));